import * as analytics from '../../../../../../shared/analytics/analytics.json';
import { ModuleList } from '../../../../../../shared/analytics/module-list';

export type SharedDrivePage = 'sharedDrives' | 'driveExplorer' | 'userDetails';
export type SharedDriveEvent = 'create_drive' | 'update_drive_shares';

export function getSharedDrivePage(
  isSharedDrives: boolean,
  isDriveExplorer: boolean
): SharedDrivePage {
  if (isSharedDrives) return 'sharedDrives';
  if (isDriveExplorer) return 'driveExplorer';
  return 'userDetails';
}

/** Event name and properties for a shared drive action on the given page. */
export function getSharedDriveAnalyticsEvent(
  event: SharedDriveEvent,
  page: SharedDrivePage
): { name: string; properties: { module: string; section: string } } {
  switch (page) {
    case 'sharedDrives':
      return {
        // The Shared Drives page has always logged creates under the Drive Explorer key.
        name:
          event === 'create_drive'
            ? analytics.drive.drive_explorer.shared_drives.create_drive
            : analytics.drive.shared_drives.update_drive_shares,
        properties: {
          module: ModuleList.modules.drive.name,
          section: ModuleList.modules.drive.sections.sharedDrives,
        },
      };
    case 'driveExplorer':
      return {
        name: analytics.drive.drive_explorer.shared_drives[event],
        properties: {
          module: ModuleList.modules.drive.name,
          section: ModuleList.modules.drive.sections.driveExplorer,
        },
      };
    case 'userDetails':
      return {
        name: analytics.user_management.user_details.drive.shared_drives[event],
        properties: {
          module: ModuleList.modules.userManagement.name,
          section: ModuleList.modules.userManagement.sections.drive,
        },
      };
  }
}
